import { render, staticRenderFns } from "./CustomerPortal.vue?vue&type=template&id=3ef4bbb8&"
import script from "./CustomerPortal.vue?vue&type=script&lang=ts&"
export * from "./CustomerPortal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports